<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Usuários Apetrus</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-slide-x-transition>
            <v-layout justify-end v-show="searchingUsuario">
               <v-flex xs1>
                  <v-tooltip bottom>
                    <v-btn
                      icon
                      color="info"
                      @click="carregarUsuarios(true)"
                      slot="activator"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                    <span>Pesquisar</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip bottom>
                    <v-btn
                      icon
                      color="primary"
                      @click="abrirDialogProjetos"
                      slot="activator"
                    >
                      <v-icon>folder</v-icon>
                    </v-btn>
                    <span>Selecionar Projeto</span>
                  </v-tooltip>
                </v-flex>
              <v-flex xs3>
                <v-select
                  outline
                  hide-details
                  single-line
                  placeholder="Filtrar por"
                  :items="filtrosUsuario"
                  item-value="value"
                  item-text="text"
                  v-model="filtro"
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  outline
                  hide-details
                  single-line
                  :placeholder="
                    filtro === 'cpf' ? 'Insira o CPF' : 'Insira as informações'
                  "
                  :mask="filtro === 'cpf' ? '###.###.###-##' : ''"
                  v-model="campoPesquisa"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-slide-x-transition>
          <v-btn
            icon
            color="info"
            @click="searchingUsuario = !searchingUsuario"
          >
            <v-icon v-if="!searchingUsuario">search</v-icon>
            <v-icon v-else>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headersUsuarios"
          :items="usuariosApetrus"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="totalItems"
          hide-actions
        >
          <v-progress-linear
            slot="progress"
            color="blue"
            indeterminate
          ></v-progress-linear>
          <template slot="headerCell" slot-scope="{ header }">
            <span class="font-weight-light" v-text="header.text" />
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.nome }}</td>
            <td class="text-xs-left">{{ props.item.sobrenome }}</td>
            <td class="text-xs-center" v-if="props.item.cpf">{{ props.item.cpf | cpf }}</td>
            <td class="text-xs-center" v-else>{{ 'Não possuí' }}</td>
            <td class="text-xs-center">{{ props.item.id_pessoa }}</td>
            <td class="text-xs-left">{{ props.item.email }}</td>
            <td class="text-xs-center">
              <v-icon color="teal" v-if="props.item.cliente" size="30"
                >check_circle</v-icon
              >
              <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
            </td>
            <td class="text-xs-center">
              <v-icon color="teal" v-if="props.item.tem_posto" size="30"
                >check_circle</v-icon
              >
              <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
            </td>
            <td class="text-xs-center">
              <v-icon color="teal" v-if="props.item.tem_empresa" size="30"
                >check_circle</v-icon
              >
              <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
            </td>
            <td>
              <v-tooltip lazy bottom>
                <v-btn
                  slot="activator"
                  flat
                  icon
                  color="red"
                  @click="apagarUsuario(props.item)"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                Excluir usuário
              </v-tooltip>
            </td>
            <td>
              <v-tooltip lazy bottom>
                <v-btn
                  slot="activator"
                  flat
                  icon
                  color="primary"
                  @click="DialogEditarUsuario(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                Editar dados do usuário
              </v-tooltip>
            </td>
            <td>
              <v-tooltip lazy bottom>
                <v-btn
                  slot="activator"
                  flat
                  icon
                  color="primary"
                  @click="detalhesUsuario(props.item)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                Visualizar dados do usuário
              </v-tooltip>
            </td>

          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination
            color="info"
            circle
            v-model="pagination.page"
            :length="pages"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog
      lazy
      width="600"
      v-model="dialogDetalhes"
      :fullscreen="$vuetify.breakpoint.xs"
    >
      <detalhes-usuario
        :usuario="usuarioSelecionado"
        @fechar="dialogDetalhes = false; carregarUsuarios(false)"
      ></detalhes-usuario>
    </v-dialog>
    <v-dialog
      lazy
      width="600"
      v-model="dialogEditar"
      :fullscreen="$vuetify.breakpoint.xs"
    >
      <dialog-editar-usuario
        :usuario="usuarioSelecionado"
        @fechar="dialogEditar = false; carregarUsuarios(false)"
        @success="showSuccess"
        @error="showError"
      ></dialog-editar-usuario>
    </v-dialog>
    <v-dialog
        v-model="dialogProjetos"
        max-width="500"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Selecionar Projeto</span>
          </v-card-title>
          <v-card-text>
            <v-select
              :items="projetos"
              item-text="codigo"
              item-value="codigo"
              v-model="projetoSelecionado"
              label="Escolha um projeto"
              return-object
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="exportarExecel" :disabled="!projetoSelecionado">
              Exportar para excel
            </v-btn>
            <v-btn flat @click="dialogProjetos = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :vertical="snackbar.vertical"
      >
        {{ snackbar.text }}
        <v-btn
          flat
          @click="snackbar.active = false"
        >
          Fechar
        </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
import DetalhesUsuario from '@/components/dialogs/DetalhesUsuario'
import DialogEditarUsuario from '@/components/dialogs/DialogEditarUsuario'

export default {
  components: { SmartLockMessage, DetalhesUsuario, DialogEditarUsuario },
  data () {
    return {
      primeiroCarregamento: false,
      campoPesquisa: '',
      dialogDetalhes: false,
      dialogEditar: false,
      filtrosUsuario: [
        { value: 'cpf', text: 'CPF' },
        { value: 'email', text: 'E-mail' },
        { value: 'telefone', text: 'Telefone' },
        { value: 'nome', text: 'Nome' },
        { value: 'id_pessoa', text: 'Número de identificação' }
      ],
      filtro: '',
      searchingUsuario: false,
      dialogEnviarEmail: false,
      usuarioSelecionado: null,
      dialogProjetos: false,
      projetos: [],
      projetoSelecionado: null,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialogSearchUser: false,
      totalItems: null,
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      headersUsuarios: [
        { text: 'Nome', align: 'left', sortable: false, value: 'nome' },
        { text: 'Sobrenome', sortable: false, value: 'sobrenome' },
        { text: 'CPF', sortable: false, value: 'cpf', align: 'center' },
        { text: 'Número de identificação', sortable: false, value: 'id_pessoa', align: 'center' },
        { text: 'Email', sortable: false, value: 'email', align: 'left' },
        { text: 'Cliente', sortable: false, align: 'center' },
        {
          text: 'Dono de posto',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Dono de empresa',
          sortable: false,
          align: 'center'
        },
        {
          sortable: false,
          align: 'center'
        },
        {
          sortable: false,
          align: 'center'
        },
        {
          sortable: false,
          align: 'center'
        }
      ]
    }
  },
  filters: {
    cpf: function (value) {
      if (!value) return ''
      value = value.toString()
      value = value.slice(0, 3) + '.' + value.slice(3, 6) + '.' + value.slice(6, 9) + '-' + value.slice(9, 11)
      return value
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    usuariosApetrus () {
      return this.$store.getters.usuariosApetrus
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    smartLock () {
      return this.$store.getters.smartLock
    }
  },
  watch: {
    pagination: {
      handler () {
        if (this.primeiroCarregamento) this.carregarUsuarios(false)
      },
      deep: true
    }
  },
  methods: {
    showSuccess (text) {
      this.snackbar.color = 'primary'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    showError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    carregarUsuarios (zerarPaginacao) {
       let filtros = {
        pagination: zerarPaginacao ? 1 : this.pagination.page
      }
      if (this.campoPesquisa) {
        switch (this.filtro) {
          case 'cpf':
            filtros['cpf__icontains'] = this.campoPesquisa
            break
          case 'nome':
            filtros['nome__icontains'] = this.campoPesquisa
            break
          case 'id_pessoa':
            filtros['id_pessoa'] = this.campoPesquisa
            break
          case 'telefone':
            filtros['telefone__icontains'] = this.campoPesquisa
            break
          case 'email':
            filtros['email__icontains'] = this.campoPesquisa
        }
      }
      this.$store
        .dispatch('carregarUsuariosApetrus', {
          page: this.pagination.page,
          filtros: filtros
        })
        .then((json) => {
          this.totalItems = json.count
          this.primeiroCarregamento = true
        })
    },
    detalhesUsuario (usuario) {
      this.usuarioSelecionado = usuario
      this.dialogDetalhes = true
    },
    DialogEditarUsuario (usuario) {
      this.usuarioSelecionado = usuario
      this.dialogEditar = true
    },
    apagarUsuario (usuario) {
      let text = 'ALERTA! \nPressione OK para confirmar a exclusão do usuário ' + usuario.nome + ' ' + usuario.sobrenome
      if (confirm(text) === true) {
        this.$store.dispatch('apagarPessoa', {
          email: usuario.email
        }).then(() => {
          this.sucess('Cliente apagado com sucesso')
          this.carregarUsuarios(false)
        }).catch(() => {
          this.erro('Não foi possível apagar cliente')
        })
      }
    },
    abrirDialogProjetos () {
      this.dialogProjetos = true
      this.pegarProjetosFirebase()
    },
    pegarProjetosFirebase () {
      this.$store.dispatch('projetosFirebase', {
        method: 'GET',
        body: {}
      }).then(json => {
         let projetosApi = json.results || json
         const projetosExtras = [
          { codigo: 'apetrus', nome: 'Apetrus' },
          { codigo: 'conecta_revendas', nome: 'Conecta Revendas' },
          { codigo: 'conecta_frota', nome: 'Conecta Frota' }
        ]
        projetosExtras.forEach(extra => {
          if (!projetosApi.some(p => p.codigo === extra.codigo)) {
            projetosApi.push(extra)
          }
        })
        this.projetos = projetosApi
      })
    },
    exportarExecel () {
      if (!this.projetoSelecionado) {
        this.showError('Selecione um projeto!')
        return
      }
      this.$store.dispatch('exportarClientesPorProjeto', this.projetoSelecionado.codigo)
        .then(() => {
          this.showSuccess('Exportação iniciada!')
        })
        .catch(() => {
          this.showError('Erro ao exportar clientes do projeto!')
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
